import React from 'react';
import PropTypes from 'prop-types';
import SelectablePlaylist from './SelectablePlaylist';
import { Drawer } from '../../Modules';
import { Button } from 'semantic-ui-react';

const DiscoverPlaylists = ({ isSelected, onClose, playlists, togglePlaylist }) =>
  <React.Fragment>
    <Drawer.Content>
      {playlists.map(({ node: playlist }) =>
        <SelectablePlaylist
          playlist={playlist}
          key={playlist.id}
          togglePlaylist={togglePlaylist}
          isSelected={isSelected}
        />
      )}
    </Drawer.Content>
    <Drawer.Footer>
      <Button
        onClick={onClose}
        primary
        content='Done'
      />
    </Drawer.Footer>
  </React.Fragment>;

DiscoverPlaylists.propTypes = {
  isSelected: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  playlists: PropTypes.array.isRequired,
  togglePlaylist: PropTypes.func.isRequired
};

export default DiscoverPlaylists;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Recommendation/DiscoverPlaylists.js